import script from "./LoginRegisterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginRegisterModal.vue?vue&type=script&setup=true&lang=js"

import "./LoginRegisterModal.vue?vue&type=style&index=0&id=0fb72aee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb72aee"]])

export default __exports__